/**
 * 获取一个唯一的随机数
 * @returns {string}
 */
export function getUniqueStr() {
	const timestamp = +new Date() + ''
	const randomNum = parseInt((1 + Math.random()) * 65536) + ''
	return (+(randomNum + timestamp)).toString(32)
}

export function getUniqueNum() {
	const timestamp = +new Date() + ''
	const randomNum = parseInt((1 + Math.random()) * 65536) + ''
	return +(timestamp + randomNum)
}

export function getUUID() {
	let reg = [1e7] + -1e3 + -4e3 + -8e3 + -1e11
	return reg.replace(/[018]/g, c => (c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16))
}

/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) {
	return /^(https?:|mailto:|tel:)/.test(path)
}

export function parseTime(time, cFormat) {
	if (arguments.length === 0 || !time) {
		return ''
	}
	const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
	let date
	if (typeof time === 'object') {
		date = time
	} else {
		if (('' + time).length === 10) time = parseInt(time) * 1000
		date = new Date(time)
	}
	const formatObj = {
		y: date.getFullYear(),
		m: date.getMonth() + 1,
		d: date.getDate(),
		h: date.getHours(),
		i: date.getMinutes(),
		s: date.getSeconds(),
		a: date.getDay()
	}
	const timeStr = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
		let value = formatObj[key]
		if (key === 'a') return ['日', '一', '二', '三', '四', '五', '六'][value]
		if (result.length > 0 && value < 10) {
			value = '0' + value
		}
		return value || 0
	})
	return timeStr
}

export function html2Text(val) {
	let reg = /<[^<>]+>/g
	val = val.toString().replace(reg, '')
	return val
}
export function headImg(val) {
	if (val !== undefined && val.substr(0, 1) === 'h') {
		return val
	} else if (val !== undefined) {
		return '/api' + val
	} else if (val == null || val === undefined) {
		return require('@/assets/images/avatar.png')
	}
}

export function objectMerge(target, source) {
	/* Merges two  objects,
     giving the last one precedence */

	if (typeof target !== 'object') {
		target = {}
	}
	if (Array.isArray(source)) {
		return source.slice()
	}
	for (const property in source) {
		if (source.hasOwnProperty(property)) {
			const sourceProperty = source[property]
			if (typeof sourceProperty === 'object') {
				target[property] = objectMerge(target[property], sourceProperty)
				continue
			}
			target[property] = sourceProperty
		}
	}
	return target
}

export function scrollTo(element, to, duration) {
	if (duration <= 0) return
	const difference = to - element.scrollTop
	const perTick = (difference / duration) * 10
	setTimeout(() => {
		console.log(new Date())
		element.scrollTop = element.scrollTop + perTick
		if (element.scrollTop === to) return
		scrollTo(element, to, duration - 10)
	}, 10)
}

export function toggleClass(element, className) {
	if (!element || !className) {
		return
	}
	let classString = element.className
	const nameIndex = classString.indexOf(className)
	if (nameIndex === -1) {
		classString += '' + className
	} else {
		classString = classString.substr(0, nameIndex) + classString.substr(nameIndex + className.length)
	}
	element.className = classString
}

export const pickerOptions = [
	{
		text: '今天',
		onClick(picker) {
			const end = new Date()
			const start = new Date(new Date().toDateString())
			end.setTime(start.getTime())
			picker.$emit('pick', [start, end])
		}
	},
	{
		text: '最近一周',
		onClick(picker) {
			const end = new Date(new Date().toDateString())
			const start = new Date()
			start.setTime(end.getTime() - 3600 * 1000 * 24 * 7)
			picker.$emit('pick', [start, end])
		}
	},
	{
		text: '最近一个月',
		onClick(picker) {
			const end = new Date(new Date().toDateString())
			const start = new Date()
			start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
			picker.$emit('pick', [start, end])
		}
	},
	{
		text: '最近三个月',
		onClick(picker) {
			const end = new Date(new Date().toDateString())
			const start = new Date()
			start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
			picker.$emit('pick', [start, end])
		}
	}
]

export function getTime(type) {
	if (type === 'start') {
		return new Date().getTime() - 3600 * 1000 * 24 * 90
	} else {
		return new Date(new Date().toDateString())
	}
}

export function debounce(func, wait, immediate) {
	let timeout, args, context, timestamp, result

	const later = function() {
		// 据上一次触发时间间隔
		const last = +new Date() - timestamp

		// 上次被包装函数被调用时间间隔last小于设定时间间隔wait
		if (last < wait && last > 0) {
			timeout = setTimeout(later, wait - last)
		} else {
			timeout = null
			// 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
			if (!immediate) {
				result = func.apply(context, args)
				if (!timeout) context = args = null
			}
		}
	}

	return function(...args) {
		context = this
		timestamp = +new Date()
		const callNow = immediate && !timeout
		// 如果延时不存在，重新设定延时
		if (!timeout) timeout = setTimeout(later, wait)
		if (callNow) {
			result = func.apply(context, args)
			context = args = null
		}

		return result
	}
}

export function deepClone(source) {
	if (!source && typeof source !== 'object') {
		throw new Error('error arguments', 'shallowClone')
	}
	const targetObj = source.constructor === Array ? [] : {}
	for (const keys in source) {
		if (source.hasOwnProperty(keys)) {
			if (source[keys] && typeof source[keys] === 'object') {
				targetObj[keys] = source[keys].constructor === Array ? [] : {}
				targetObj[keys] = deepClone(source[keys])
			} else {
				targetObj[keys] = source[keys]
			}
		}
	}
	return targetObj
}

/**
 *  获取两个时间段之间的时长
 *  start end  完整时间戳
 * */

export function timeDuration(start, end) {
	if (!start || (typeof start !== 'number' && start.constructor !== Date)) {
		throw new Error('error arguments')
	}
	if (!end || (typeof end !== 'number' && end.constructor !== Date)) {
		throw new Error('error arguments')
	}
	start = typeof start !== 'number' ? +new Date(start) : start
	end = typeof end !== 'number' ? +new Date(end) : end
	const duration = start < end ? (end - start) / 1000 : (start - end) / 1000
	const seconds = (duration % 60) + '秒'
	const minute = (parseInt(duration / 60) % 60) + '分'
	const hours = parseInt(duration / 3600) ? parseInt(duration / 3600) + '小时' : ''
	// const day = parseInt(duration / 3600 / 24) % 24 > 0 ? parseInt(duration / 3600 / 24) % 24 + '天' : ''
	return hours + minute + seconds
}

export function trim(str) {
	return String.prototype.trim.call(str)
}

export function isType(arg, type) {
	return Object.prototype.toString.call(arg) === '[object ' + type + ']'
}

export function parseQuery() {
	const res = {}

	const query = (location.href.split('?')[1] || '').trim().replace(/^(\?|#|&)/, '')

	if (!query) {
		return res
	}

	query.split('&').forEach(param => {
		const parts = param.replace(/\+/g, ' ').split('=')
		const key = decodeURIComponent(parts.shift())
		const val = parts.length > 0 ? decodeURIComponent(parts.join('=')) : null

		if (res[key] === undefined) {
			res[key] = val
		} else if (Array.isArray(res[key])) {
			res[key].push(val)
		} else {
			res[key] = [res[key], val]
		}
	})

	return res
}

export function quickSort(list, field, type) {
	if (list.length < 2) {
		return list
	}
	// field 字段 type 上升up（默认）  下降down
	for (let i = 0; i < list.length; i++) {
		let n = i
		for (let j = i + 1; j < list.length; j++) {
			let one = field ? +list[j][field] : +list[j],
				two = field ? +list[n][field] : +list[n]
			if (type === 'down') {
				if (one > two) {
					n = j
				}
			} else {
				if (one < two) {
					n = j
				}
			}
		}
		let chat = list[i]
		list[i] = list[n]
		list[n] = chat
	}
	return list
}
export function formatSeconds(times) {
	var result = "00:00:00";
	var hour, minute, second;
	if (times > 0) {
		hour = Math.floor(times / 3600);
		if (hour < 10) {
			hour = "0" + hour;
		}
		minute = Math.floor((times - 3600 * hour) / 60);
		if (minute < 10) {
			minute = "0" + minute;
		}
		second = Math.floor((times - 3600 * hour - 60 * minute) % 60);
		if (second < 10) {
			second = "0" + second;
		}
		result = hour + ":" + minute + ":" + second;
	}
	return result;
}


const VUE_APP_API_URL = process.env.VUE_APP_API_URL || `${location.origin}/api`
const VUE_APP_WS_URL = process.env.VUE_APP_WS_URL || `ws:${location.hostname}:20003`

export { VUE_APP_API_URL, VUE_APP_WS_URL }
